import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { BUDGETS, ENQ_STATUSES, LEAD_DESTINATIONS, LEAD_SOURCES, TRIP_TYPES } from "@/lib/constants";

export const Pick = ({ label, value, onChange, options, testId, placeholder }) => (
  <div className="space-y-1.5">
    <Label>{label}</Label>
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="h-10" data-testid={testId}><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent className="bg-white max-h-72">{options.map((o) => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)}</SelectContent>
    </Select>
  </div>
);

export const FollowUpInputs = ({ f, set, prefix }) => (
  <div className="grid grid-cols-2 gap-3">
    <div className="space-y-1.5">
      <Label htmlFor={`${prefix}-followup`}>Follow-up date</Label>
      <Input id={`${prefix}-followup`} type="date" value={f.follow_up_date || ""} onChange={(e) => set("follow_up_date")(e.target.value)} className="h-10" data-testid={`${prefix}-followup-input`} />
    </div>
    <div className="space-y-1.5">
      <Label htmlFor={`${prefix}-followup-time`}>Time</Label>
      <Input id={`${prefix}-followup-time`} type="time" value={f.follow_up_time || ""} onChange={(e) => set("follow_up_time")(e.target.value)} className="h-10" data-testid={`${prefix}-followup-time-input`} />
    </div>
  </div>
);

export const LeadPipelineFields = ({ f, set, prefix }) => (
  <div className="grid gap-3 sm:grid-cols-2">
    <Pick label="Stage" value={f.status} onChange={set("status")} options={ENQ_STATUSES} testId={`${prefix}-status`} />
    <FollowUpInputs f={f} set={set} prefix={prefix} />
    <Pick label="Source" value={f.source} onChange={set("source")} options={LEAD_SOURCES} testId={`${prefix}-source`} />
    <Pick label="Requirement" value={f.trip_type} onChange={set("trip_type")} options={TRIP_TYPES} testId={`${prefix}-trip`} placeholder="Not set" />
    <Pick label="Destination" value={f.destination} onChange={set("destination")} options={LEAD_DESTINATIONS} testId={`${prefix}-destination`} placeholder="Not set" />
    <Pick label="Budget (per person)" value={f.budget} onChange={set("budget")} options={BUDGETS} testId={`${prefix}-budget`} placeholder="Not set" />
    <div className="space-y-1.5 sm:col-span-2">
      <Label htmlFor={`${prefix}-notes`}>Internal notes</Label>
      <Textarea id={`${prefix}-notes`} rows={3} maxLength={3000} value={f.notes} onChange={(e) => set("notes")(e.target.value)} data-testid={`${prefix}-notes-input`} placeholder="Budget, hotel preference, next step..." />
    </div>
  </div>
);
